import { effectInit } from 'swiper/effect-utils'

export default function EffectCircular({ swiper, extendParams, on }) {
  extendParams({
    circularEffect: {
      slideShadows: false,
      radius: 200,
      itemRotation: 30,
      translateFactor: 1.5
    }
  })

  const setTranslate = () => {
    const { slides } = swiper
    const params = swiper.params.circularEffect

    const slideHeight = swiper.height
    const slideWidth = swiper.width
    const verticalTranslate = slideHeight * params.translateFactor

    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i]
      const rotateZ = params.itemRotation * i
      const ty = -verticalTranslate

      slideEl.style.width = `${slideWidth}px`
      slideEl.style.height = `${slideHeight}px`
      slideEl.style.transformOrigin = `50% ${-ty}px`
      slideEl.style.transform = `translateX(-50%) translateY(${ty}px) rotate(${rotateZ}deg)`
    }

    const currentIndex = (slides.length - 1) * swiper.progress
    const rz = currentIndex * params.itemRotation

    swiper.wrapperEl.style.top = `${verticalTranslate}px`
    swiper.wrapperEl.style.transform = `rotate(${-rz}deg)`
  }

  const setTransition = (duration) => {
    swiper.slides.forEach((slideEl) => {
      slideEl.style.transitionDuration = `${duration}ms`
    })
  }

  effectInit({
    effect: 'circular',
    swiper,
    on,
    setTranslate,
    setTransition,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: true
    })
  })
}
